import React, { PureComponent } from 'react'
import { BrowserRouter, Route, Redirect, Switch, HashRouter } from 'react-router-dom'
//import { HashLink as Link} from 'react-router-hash-link'
import { Dimmer, Loader } from 'semantic-ui-react'
import Home from '../../pages/Home'
import CaseStudies from '../../pages/CaseStudies'
import GettingStarted from '../../pages/GettingStarted'
import Dashboard from '../../pages/Dashboard'
import Documentation from '../../pages/Documentation'
import Tools from '../../pages/Tools'
import Community from '../../pages/Community'
import Apis from '../../pages/Apis'
import Confirm from '../../pages/Confirm'
import ConfirmEmail from '../../pages/ConfirmEmail'
import ForgotPassword from '../../pages/ForgotPassword'
import UpdateEmail from '../../pages/UpdateEmail'
import ApiDetails from '../../pages/ApiDetails'
import SignInRedirect from '../../pages/SignInRedirect'
import Account from '../../pages/Account'
import Reference from '../../pages/Reference'
import NLReference from '../../pages/ReferenceNL'
import ReferenceLegacy from '../../pages/ReferenceLegacy'
import ConstructExAPI from '../../pages/ConstructExRef'
import ConstructExAdmin from '../../pages/ConstructExAdmin'
import ProjectCenterAdmin from '../../pages/ProjectCtrAdmin'
import LegacySetup from '../../pages/LegacySetup'
import Updates from '../../pages/Updates'
import Admin from '../../pages/Admin'
import AlertPopup from '../../components/AlertPopup'
import { init, isAuthenticated } from '../../services/self'
import { apiGatewayClient } from '../../services/api'
import Login from '../SignIn'
import './App.css'


const NoMatch = () => <h2>We apologize the page you are looking for is missing or was typed incorrectly.</h2>


//Start Class MatchWhenAuthorized-------------------------
class MatchWhenAuthorized extends PureComponent { // eslint-disable-line
  constructor(props) {
    super(props)

    const apiGatewayClientInterval = window.setInterval(() => {
      if (apiGatewayClient) {
        window.clearInterval(apiGatewayClientInterval)
        this.setState({apiGatewayClient})
      }
    }, 100)

    this.state = {apiGatewayClient, apiGatewayClientInterval}
  }

  componentWillUnmount() {
    if (this.state.apiGatewayClientInterval) window.clearInterval(this.state.apiGatewayClientInterval)
  }

  render() {
    const {component: Component, ...rest} = this.props

    return <Route {...rest} render={props => {
      if (!isAuthenticated()) return <Redirect to={{ pathname: '/', state: { from: props.location } }}/>

      return this.state.apiGatewayClient ? <Component {...props} />: (<Dimmer active>
        <Loader content='Loading' />
      </Dimmer>)
    }} />
  }
}//End Class MatchWhenAuthorized-----------------------------
let styles = {
  padding: '0px'
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    isAuthenticated()
      ? <Component {...props} />
      : <Redirect to='/signinredirect' />
  )} />
)


export default class App extends PureComponent {
  constructor() {
    super()
    init()

    // We are using an S3 redirect rule to prefix the url path with #!
    // This then converts it back to a URL path for React routing
    // NOTE: For local development, you will get a Page Not Found when refreshing the Swagger UI page when it has a #!


    const hashRoute = location.hash.substring(2)
    history.pushState({}, 'home page', hashRoute)
  }


reload = () => {window.location.reload();}

  render() {
    return (
      <BrowserRouter>
      <div className="App">
        <section className="App-intro" style={styles} >
            <AlertPopup />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/case-studies" component={CaseStudies} />
              <Route path="/getting-started" component={GettingStarted} />
              <Route path="/documentation" component={Documentation} />
              <Route path="/tools" component={Tools} />
              <Route path="/community" component={Community} />
              <Route path="/dashboard" component={Dashboard} />
              <PrivateRoute exact path="/apis" component={Apis} />
              <Route path="/apis/:apiId" component={ApiDetails} />
              <Route path="/signinredirect" component={SignInRedirect} />
              <Route path="/confirm" component={Confirm} />
              <Route path="/updateEmail" component={UpdateEmail} />
              <Route path="/confirmEmail" component={ConfirmEmail} />
              <Route path="/forgotPassword" component={ForgotPassword} />
              <Route path="/reference" component={Reference} />
              <PrivateRoute exact path="/account" component={Account} />
              //<PrivateRoute exact path="/reference" component={Reference} />
              <Route path="/nlreference" component={NLReference} />
              //previously private routes
              <Route path="/referencelegacy" component={ReferenceLegacy} />
              <Route path="/constructexapi" component={ConstructExAPI} />
              <Route path="/projectctradmin" component={ProjectCenterAdmin} />
              <Route path="/constructexadmin" component={ConstructExAdmin} />
              <Route path="/legacysetup" component={LegacySetup} />
              <Route path="/admin" component={Admin} />
              <Route path="/signin" component={Login} />
              <Route path="/updates" component={Updates} />
              <Route component={NoMatch} />
            </Switch>
        </section>
      </div>
      </BrowserRouter>

    )
    /*


     */
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/App/index.js
 **/